import { ITwoFALoginFormProps } from "./TwoFALoginForm.types";
import TwoFALoginFormContainer from "./TwoFALoginForm.container";
import React from "react";

const LoginForm: React.FC<ITwoFALoginFormProps> = props => (
  <TwoFALoginFormContainer {...props} />
);

export default LoginForm;
